import { Box, Stack, Text, Link } from "@chakra-ui/layout";

import SearchBar from "components/search-bar";
import React, { useEffect, useState } from "react";
import Tweets from "components/tweets";

import { useSession } from "next-auth/react";

import ProtectedRoute from "components/protected-route";

import { getHooks } from "../controllers/search";
import { useRouter } from "next/dist/client/router";
import { Page } from "components/page";

import { MainContext } from "../context/mainContext";
import { getAccount } from "../utils/sessionHelper";
import * as analytics from 'utils/analytics';
import { GeneratorsAISVGIcon } from "components/sidebar/icons/GeneratorsAISVGIcon";
import { textStyle, layerStyle, radius } from "theme/names";
import { UpgradeToProCard } from "components/upgrade-to-pro-card";
import { getPlan } from "controllers/subscription";
import { UpgradePopup } from "components/upgrade-popup";

const Hook = () => {
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"
  const [recos, setRecos] = React.useState([]);
  const [isSending, setIsSending] = React.useState(false);
  const [data, setData] = React.useState<any>(null);
  const [hooks, setHooks] = React.useState<any>([]);
  const [hasFetched, setHasfetched] = useState<boolean>(false);
  const mainContext = React.useContext(MainContext);
  const router = useRouter();

  useEffect(() => {
    const { from, idea } = router.query;
    if (session && session?.user) {
      analytics.log('hook_generator_viewed');
    }
    if (session && !hasFetched && from && idea) {
      setHasfetched(true);
      sendRequest(session, idea);
    }
  }, [session]);

  const sendRequest = async (session, topic) => {
    if (isSending) return;
    analytics.log('hook_generator_generate_clicked');

    setIsSending(true);

    let params: any = {
      topic: topic,
      count: 3,
      isInfluentLeader: true,
      bio: getAccount(session)?.keywords?.join(","),
      description: getAccount(session)?.description,
    };

    //@ts-ignore
    let data = await getHooks(session, params, mainContext);

    if (!data || (data.success === 0 && !data?.data?.hooks)) {
      setHooks(null);
    } else {
      let newHooks: any = [];
      data.data.hooks.forEach((hook) => {
        let tw = {
          full_text: hook,
          user: {
            //@ts-ignore
            profile_image_url_https: getAccount(session).image,
            name: getAccount(session).name,
            screen_name: getAccount(session).userName,
            firstName: getAccount(session)?.user?.firstName,
            lastName: getAccount(session)?.user?.lastName,
          },
        };
        newHooks.push(tw);
      });
      console.log(newHooks);
      setHooks(newHooks);
    }

    setIsSending(false);
  };

  if (!loading && !session) {
    return <ProtectedRoute />;
  }
  const plan = getPlan(session?.user);
  const isStarterPlan = plan === "start";

  return (
    <Page
      title="Hook generator"
      titleIconWrapperProps={{ gap: 3 }}
      description="Tell us what your post is about and we'll generate an eye-catching hook for it."
      descriptionWrapperProps={{ pt: "4", pb: "5" }}
    >
      {isStarterPlan ? (
        <UpgradePopup
          currentPlan={plan}
          feature="Hook Generator"
          availablePlans={["grow", "enterprise"]}
        />
      ) : (
        <Stack spacing="10">
          <Box
            p="8"
            layerStyle={layerStyle["bg.border.rounded"]}
            borderRadius={radius.lg}
          >
            <Text textStyle={textStyle["h3.bold.standard"]}>
              What is your post about?
            </Text>
            <SearchBar
              sendRequest={sendRequest}
              isLoading={isSending}
              placeholder="5 steps to improve..."
              aiButton={true}
              isSending={isSending}
              setIsSending={setIsSending}
              setData={setData}
              disableFilters={true}
              searchMode="hooks"
              inputWidth="md"
              mt={4}
              size="md"
              showButton={true}
              buttonText="Generate hooks"
              showSearchButtonRightIcon={false}
              searchButtonLeftIcon={<GeneratorsAISVGIcon />}
              showSearchIconInInput={false}
              disableButtonOnEmptyInput={true}
            />
          </Box>
          {
            //@ts-ignore
            !isSending && hooks && (
              <Box pt={10}>
                <Tweets
                  //@ts-ignore
                  sendRequest={sendRequest}
                  //@ts-ignore
                  tweets={hooks}
                  //@ts-ignore
                  data={data}
                  //@ts-ignore
                  setData={setData}
                  disableBlur={false}
                  disableBookmarkButton={true}
                  disableRequest={true}
                  disableSaveCsv={true}
                  disableEmbed={true}
                  disableTryAgain={false}
                  disableSubMenu={true}
                  disableRetweet={true}
                  disableLike={true}
                  disableUserPopup={true}
                  isVariation={true}
                  disableName={false}
                  addToComposerBtnText="Use this hook"
                  showCopyToClipboard={true}
                  showWarningOnAddToComposer={true}
                  disableTweetSelection={true}
                />
              </Box>
            )
          }
        </Stack>
      )}
    </Page>
  );
};

export default Hook;
